import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import Setup from "@/pages/Setup";
import PinGate from "@/pages/PinGate";
import Home from "@/pages/Home";
import Feed from "@/pages/Feed";
import CatchDetail from "@/pages/CatchDetail";
import Settings from "@/pages/Settings";
import AppShell from "@/components/AppShell";
import InstallPrompt from "@/components/InstallPrompt";
import { Toaster } from "sonner";

function Splash() {
  return (
    <div className="wc-shell flex flex-col items-center justify-center gap-6 text-center px-8">
      <div className="text-7xl animate-pulse">🎣</div>
      <div className="font-display text-3xl font-black text-[#0A3D62]">Glenlyon Fishing Challenge</div>
      <div className="text-[#556B7D]">Reeling it in…</div>
    </div>
  );
}

function Gate() {
  const { loading, family, unlocked } = useApp();
  const location = useLocation();

  if (loading) return <Splash />;
  if (!family) return <Setup />;
  if (!unlocked) return <PinGate />;

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/feed" element={<Feed />} />
        <Route path="/catch/:id" element={<CatchDetail />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Gate />
        <Toaster
          position="top-center"
          richColors={false}
          toastOptions={{
            style: {
              background: "#0A3D62",
              color: "#FAF8F3",
              border: "1px solid rgba(232,168,56,0.4)",
              borderRadius: "1rem",
              padding: "1rem 1.25rem",
              boxShadow: "0 10px 40px rgba(10,61,98,0.35)",
            },
          }}
        />
        <InstallPrompt />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
